import React, {Component} from "react";
import _ from 'lodash';
import Loading from "./../../loading";

class MunsModal extends Component {
	render() {
		let {conclusion, modality, muns, show, selectedMuns} = this.props;
		let municipalities = modality === 3 ? _.filter(muns.list, {modality_id: 3}) : muns.list;
		return show ? <div className={`modal${this.props.active ? ' is-active' : ''}`}>
			<div className="modal-background" onClick={() => this.props.closeModal()}/>
			<div className="modal-content">
				<div className="message">
					<div className="message-header">
						<p>Seleccione los municipios participantes</p>
						<button type="button" onClick={() => this.props.closeModal()} className="delete is-medium"
						        aria-label="delete"></button>
					</div>
					<div className="message-body">
						{muns.isFetching ? <Loading message="Cargando municipios..."/> :
							<div className="field is-grouped is-grouped-multiline">
								{_.map(municipalities, (municipality, k) => {
									let shouldCheck = _.findKey(selectedMuns, {agenciable_id: municipality.id}) !== undefined ? true : false;
									return (
										<div className="control" key={k}>
											<label htmlFor={`mun-${municipality.id}`} className="checkbox"
											       disabled={conclusion}>
												<input
													id={`mun-${municipality.id}`}
													ref={`g-mun-${municipality.id}`}
													value={municipality.id}
													type="checkbox"
													checked={shouldCheck}
													className="checkbox"
													onChange={() => this._saveMuns(municipality, k)}
													disabled={conclusion}
												/>
												{municipality.name}
											</label>
										</div>
									)
								})}
							</div>
						}

						<br/><br/>
						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button className="button is-info" type="button" onClick={() => this.props.closeModal()}>
									Cerrar
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div> : <p></p>
	}

	_saveMuns(agency, index) {
		if (this.refs[`g-mun-${agency.id}`].checked) {
			this.props.add(`project.registry.data.project_goals[${this.props.selectedGoal}].agencies`, {
				agenciable: {...agency},
				agenciable_id: agency.id,
				id: agency.id
			});
		} else {
			this.props.remove(`project.registry.data.project_goals[${this.props.selectedGoal}].agencies`, index);
		}
	}
}

export default MunsModal;


// WEBPACK FOOTER //
// ./src/elements/project/widgets/project_muns_modal_widget.jsx